<!--站点线路-->
<template>
  <div class="tw-zdxl">
    <div class="tw-zdxl-head">
      <div class="tw-zdxl-head-title">紫荆港校区</div>
      <van-icon
        name="arrow-left"
        size="30"
        color="#000000"
        @click="handleBackClick"
        class="tw-zdxl-head-icon"
      />
    </div>
    <div class="tw-zdxl-body">
      <div class="tw-zdxl-body-title">
        <div class="tw-zdxl-body-title-text">线路</div>
      </div>
      <div class="tw-zdxl-body-list">
        <div
          class="tw-zdxl-body-list-item"
          v-for="(item, index) in busInfoList"
          :key="index"
          @click="handleItemClick(item)"
        >
          <div class="tw-zdxl-body-list-item-linename">{{item.linename}}</div>
          <div class="tw-zdxl-body-list-item-starend">{{item.starend}}</div>
          <div class="tw-zdxl-body-list-item-next">下一班次:{{item.next}}</div>
          <div class="tw-zdxl-body-list-item-status">{{item.status == 0? '等待发车':'已发车'}}</div>
          <div class="tw-zdxl-body-list-item-timetable">{{item.timeTable}}</div>
          <div class="tw-zdxl-body-list-item-bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StationLine",
  data() {
    return {
      busInfoList: [
        {
          linename: "教师1号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师2号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师3号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师4号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师5号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师6号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师6号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师6号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师6号线",
          starend: "紫金港校区-玉泉校区",
          next: "09:45",
          status: 0,
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
      ],
    };
  },
  methods: {
    handleBackClick() {
      window.history.go(-1);
    },
    //item点击
    handleItemClick(item) {
      console.info(item);
      this.$router.push({
        path: "/zdxl/xlxq",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tw-zdxl {
  height: 100%;
  &-head {
    height: 6%;
    background-color: #fff;
    position: relative;
    &-title {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 3px;
      padding-top: 4%;
      color: #000;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 20%;
    }
  }
  &-body {
    height: 94%;
    overflow: auto;
    &-title {
      height: 3%;
      background-color: #c0c0c0;
      &-text {
        font-size: 14px;
        padding-left: 4%;
        padding-top: 1%;
        color: #9a9fa5;
      }
    }
    &-list {
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      :last-child {
        border: none;
      }
      &-item {
        height: 12%;
        position: relative;
        &-linename {
          position: absolute;
          margin-left: 5%;
          font-weight: 550;
          top: 13%;
          left: 0;
        }
        &-starend {
          position: absolute;
          margin-left: 5%;
          font-size: 12px;
          bottom: 40%;
          color: #a9a9a9;
          left: 0;
        }
        &-next {
          position: absolute;
          margin-left: 5%;
          bottom: 40%;
          color: #2070fd;
          right: 5%;
        }
        &-status {
          margin-left: 5%;
          position: absolute;
          top: 13%;
          right: 10%;
        }
        &-timetable {
          margin-left: 5%;
          position: absolute;
          bottom: 13%;
          left: 0%;
          color: #9a9fa5;
        }
        &-bottom {
          position: absolute;
          bottom: 0;
          height: 10px;
          width: 100%;
          background-color: #9a9fa5;
        }
      }
    }
  }
}
</style>